var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDsNewIcon = function SvgDsNewIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M13.639 1.596c.85-.239 1.694.4 1.694 1.284v8.787c0 .854-.792 1.488-1.626 1.3L9.76 12.08l-1.691 1.998c-.317.374-.782.59-1.272.59h-1.5c-.92 0-1.666-.746-1.666-1.667v-2.3l-1.923-.432a1.33 1.33 0 0 1-1.04-1.301V6.255c0-.597.397-1.122.972-1.284zM4.963 11v2c0 .184.15.333.333.333h1.5a.33.33 0 0 0 .254-.118l1.241-1.466zM14 2.88 5.704 5.213V9.8L14 11.667zM2 6.255l2.37-.667V9.5L2 8.967z",
    clipRule: "evenodd"
  })));
};
export default SvgDsNewIcon;